import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class SixCardValues {
  constructor(component) {
    this.refs = {
      slider: '.js-slider',
      prev: '.js-prev',
      next: '.js-next',
      card: '.js-card',
    };

    this.dom = {
      $component: component,
      $slider: component.querySelector(this.refs.slider),
      $prev: component.querySelector(this.refs.prev),
      $next: component.querySelector(this.refs.next),
      $cards: component.querySelectorAll(this.refs.card),
    };

    this.state = {
      slider: null,
    };

    this.init();

    this.mount();
  }

  init() {
    const { dom, state } = this;

    if (!dom.$slider) return;

    state.slider = new Swiper(dom.$slider, {
      modules: [Navigation],
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        prevEl: dom.$prev,
        nextEl: dom.$next,
      },
      breakpoints: {
        1200: {
          slidesPerView: 6,
          allowTouchMove: false,
        }
      }
    });

    // Initialize accessibility states
    dom.$cards.forEach($card => {
      const isActive = $card.classList.contains('is-active');
    });
  }

  mount() {
    const { dom, state } = this;

    if (!dom.$cards.length) return;

    dom.$cards.forEach($card => {
      $card.addEventListener('click', this.handleCardClick.bind(this));
      $card.addEventListener('mouseenter', this.toggleCard.bind(this));
      $card.addEventListener('focus', this.toggleCard.bind(this));
    });
  }

  handleCardClick(e) {
    const { dom, state } = this;
    const $card = e.currentTarget;

    this.toggleCard(e);
    state.slider.slideNext();
  }

  toggleCard(e) {
    const { dom, state } = this;
    
    const $card = e.currentTarget;

    dom.$cards.forEach($card => {
      $card.classList.remove('is-active');
    });

    $card.classList.add('is-active');
  }
}

const $sixCardValues = document.querySelector('.js-six-card-values');
if ($sixCardValues) new SixCardValues($sixCardValues);